import * as S from './styles';
import CurrencyFormat from 'react-currency-format';
import { Checkbox, FormControlLabel, Tooltip } from '@material-ui/core';
import { useState } from 'react';

const CheckboxFilter = ({ label, valueLabel, onChange, name, disabled }) => {
  const [checked, setChecked] = useState(false);

  return (
    <S.Wrapper>
      <FormControlLabel
        name={name}
        control={
          <Checkbox
            checked={checked}
            disabled={disabled}
            onChange={(e) => {
              setChecked(!checked);
              onChange({ name: name, checked: !checked, label: label });
            }}
          />
        }
        label={
          <CheckboxLabelAdornment
            label={label}
            value={!disabled ? valueLabel : 0}
          />
        }
      />
    </S.Wrapper>
  );
};

const truncateAtWord = (text, maxLength) => {
  if (!text || text.length <= maxLength) return text;
  const truncated = text.substring(0, maxLength);
  const lastSpace = truncated.lastIndexOf(' ');
  return (lastSpace > 0 ? truncated.substring(0, lastSpace) : truncated) + '...';
};

const CheckboxLabelAdornment = ({ label, value, currency }) => {
  const truncated = truncateAtWord(label, 25);
  const needsTooltip = label && label.length > 25;
  return (
    <S.CheckboxLabelAdornment>
      <Tooltip title={needsTooltip ? label : ''} placement="top">
        <p>{truncated}</p>
      </Tooltip>
      <p>
        {value !== 0 && currency ? (
          <CurrencyFormat
            value={value}
            displayType={'text'}
            decimalSeparator=','
            decimalScale={2}
            prefix={'R$ '}
          />
        ) : (
          value
        )}
      </p>
    </S.CheckboxLabelAdornment>
  );
};

export default CheckboxFilter;
